const Salary = [
  { name: '〜３００万円まで', value: 3000000 },
  { name: '〜５００万円まで', value: 5000000 },
  { name: '〜７００万円まで', value: 7000000 },
  { name: '〜１０００万円まで', value: 10000000 },
  { name: '〜１５００万円まで', value: 15000000 },
  { name: '〜２０００万円まで', value: 20000000 },
];

export default Salary;
